(() => {
 const dialog=document.querySelector('#bp-spin-demo');
 if(dialog){
  let opener=null, spinTimer=0, openTimer=0;
  let shownThisPage=false;
  const seen=()=>{try{return shownThisPage||localStorage.getItem('bp-fun-wheel-seen-v1')==='1'||sessionStorage.getItem('bp-fun-wheel-seen-v1')==='1';}catch{return shownThisPage;}};
  const mark=()=>{shownThisPage=true;try{localStorage.setItem('bp-fun-wheel-seen-v1','1');}catch{}try{sessionStorage.setItem('bp-fun-wheel-seen-v1','1');}catch{}};
  const close=()=>{mark();clearTimeout(spinTimer);clearTimeout(openTimer);dialog.close();opener?.focus?.();};
  dialog.addEventListener('cancel',()=>{mark();clearTimeout(spinTimer);clearTimeout(openTimer);});
  dialog.querySelector('[data-spin-close]').addEventListener('click',close);
  dialog.querySelector('[data-spin-later]')?.addEventListener('click',close);
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
  dialog.querySelector('[data-spin-button]').addEventListener('click',e=>{
   const button=e.currentTarget;button.disabled=true;button.textContent=button.dataset.spinning;
   const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
   dialog.querySelector('.bp-spin__wheel').style.transform='rotate(1800deg)';
   spinTimer=setTimeout(()=>{dialog.querySelector('[data-spin-result]').textContent=button.dataset.result;dialog.querySelector('.bp-spin__stage').hidden=true;dialog.querySelector('[data-spin-panel]').hidden=false;button.hidden=true;},reduced?50:3900);
  });
  const open=()=>{
   if(seen())return;
   if(document.hidden||document.querySelector('dialog[open],cart-drawer.active,menu-drawer details[open],product-modal[open]')){openTimer=setTimeout(open,1500);return;}
   opener=document.activeElement;mark();dialog.showModal();dialog.querySelector('[data-spin-close]').focus();
  };
  if(!seen())openTimer=setTimeout(open,10000);
  addEventListener('pagehide',()=>{clearTimeout(openTimer);clearTimeout(spinTimer);},{once:true});
 }
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const curveInit=()=>{
  document.querySelectorAll('#top-theme-picks').forEach(root=>{
   if(root.dataset.curveReady||reduced.matches)return;
   const stage=root.querySelector('.bp-discovery__grid'),cards=[...stage.children];
   if(cards.length<3)return;
   root.dataset.curveReady='true';root.classList.add('bp-curve-ready');
   let phase=0,last=0,frame=0,dragging=false,dragged=false,startX=0,lastX=0,pauseUntil=0,focus=false,visible=false;
   const sizes=()=>{const small=matchMedia('(max-width:749px)').matches;return{width:stage.clientWidth,card:small?110:150,step:small?128:176};};
   const draw=()=>{
    const s=sizes(),total=cards.length*s.step,radius=Math.max(450,s.width*.95);
    cards.forEach((card,i)=>{
     const x=((i*s.step-phase+s.step)%total+total)%total-s.step;
     const dx=x+s.card/2-s.width/2,y=30+(dx*dx)/(2*radius),angle=Math.atan(dx/radius)*180/Math.PI;
     card.style.transform='translate3d('+x+'px,'+y+'px,0) rotate('+angle+'deg)';
    });
   };
   const tick=t=>{
    const dt=last?Math.min(t-last,50):0;last=t;
    if(visible&&!document.hidden&&!dragging&&!focus&&t>pauseUntil&&!reduced.matches)phase+=dt*.025;
    const total=cards.length*sizes().step;phase=((phase%total)+total)%total;draw();frame=requestAnimationFrame(tick);
   };
   if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;},{rootMargin:'100px'}).observe(root);else visible=true;
   stage.addEventListener('pointerdown',e=>{dragging=true;dragged=false;startX=e.clientX;lastX=e.clientX;pauseUntil=performance.now()+4000;});
   stage.addEventListener('pointermove',e=>{if(!dragging)return;if(Math.abs(e.clientX-startX)>7)dragged=true;if(dragged){phase-=e.clientX-lastX;lastX=e.clientX;draw();}});
   const release=()=>{dragging=false;pauseUntil=performance.now()+4000;};
   stage.addEventListener('pointerup',release);stage.addEventListener('pointercancel',release);stage.addEventListener('pointerleave',release);
   stage.addEventListener('click',e=>{if(dragged){e.preventDefault();dragged=false;}},true);
   stage.addEventListener('focusin',e=>{focus=true;const i=cards.indexOf(e.target.closest('a'));if(i>=0){const s=sizes();phase=i*s.step-(s.width-s.card)/2;draw();}});
   stage.addEventListener('focusout',()=>{focus=false;});
   addEventListener('resize',draw,{passive:true});draw();frame=requestAnimationFrame(tick);
   addEventListener('pagehide',()=>cancelAnimationFrame(frame),{once:true});
  });
 };
 curveInit();
 const clips=[...document.querySelectorAll('[data-bp-video-loop]')];
 clips.forEach(v=>{v.muted=true;v.loop=true;v.playsInline=true;});
 if('IntersectionObserver' in window){
  const observer=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{
   if(isIntersecting&&!reduced.matches&&!document.hidden)target.play().catch(()=>{});else target.pause();
  }),{threshold:.35});
  clips.forEach(v=>observer.observe(v));
 }
 document.addEventListener('visibilitychange',()=>{clips.forEach(v=>{const r=v.getBoundingClientRect();if(document.hidden||reduced.matches||r.bottom<0||r.top>innerHeight)v.pause();else v.play().catch(()=>{});});});
})();
